import { useState, useEffect } from 'react';

export default function useDenimFeatureTestHook(hasDenimElevatedAttrFeatureTest, denimElevatedAndScalesFlag) {
  const [DenimFeatureState, setDenimFeatureState] = useState({
    hasScales: false,
    hasElevatedFitDescription: false,
  });

  useEffect(() => {
    if (hasDenimElevatedAttrFeatureTest) {
      switch (denimElevatedAndScalesFlag) {
        case 'a':
          // Test  “Control”: Scales Alone
          setDenimFeatureState({
            hasScales: true,
            hasElevatedFitDescription: false,
          });
          break;
        case 'b':
          // Test B - Elevated Fit Description Alone (hiding scales)
          setDenimFeatureState({
            hasScales: false,
            hasElevatedFitDescription: true,
          });
          break;
        case 'c':
          // Test C - Scales + Elevated Fit Description
          setDenimFeatureState({
            hasScales: true,
            hasElevatedFitDescription: true,
          });
          break;
        default:
          // Default case to reset to initial state
          setDenimFeatureState({
            hasScales: false,
            hasElevatedFitDescription: false,
          });
      }
    } else {
      // Reset to initial state if the feature test is not enabled
      setDenimFeatureState({
        hasScales: false,
        hasElevatedFitDescription: false,
      });
    }
  }, [hasDenimElevatedAttrFeatureTest, denimElevatedAndScalesFlag]);

  return DenimFeatureState;
}
